import React from "react";
import PropTypes from "prop-types";
import ModalToBody from "../../../../base/ModalToBody";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { returnRental } from "../../../../services/api/rentals";
import { defaultSuccess } from "../../../../libs/utils";
import RentalReturnForm from "../../../forms/RentalReturnForm";

class ReturnBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };

    this._hideModal = this._hideModal.bind(this);
    this._showModal = this._showModal.bind(this);
    this._quickReturn = this._quickReturn.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    item: PropTypes.object,
    reload: PropTypes.func
  };

  _showModal() {
    this.setState({
      showModal: true
    });
  }

  _hideModal() {
    this.setState({
      showModal: false
    });
  }

  _quickReturn() {
    const { item: rental } = this.props;

    returnRental(rental.eventId, rental.id, {
      returnedByCrewMemberId: rental.lentByCrewMemberId,
      returnCondition: "perfect"
    }).then(response => {
      defaultSuccess(`${rental.material.name} has been returned`);
      this.props.reload();
    });
  }

  _handleSubmit(values) {
    const { item: rental } = this.props;

    returnRental(rental.eventId, rental.id, {
      returnedByCrewMemberId: values.crewMemberId,
      returnCondition: values.condition,
      returnRemark: values.remark
    }).then(response => {
      this._hideModal();
      defaultSuccess(`${rental.material.name} has been returned`);
      this.props.reload();
    });
  }

  render() {
    const { showModal } = this.state;
    const { item: rental } = this.props;

    return [
      <span key="button">
        <button
          className="btn btn-outline-accent m-btn btn-sm  m-btn--icon m--margin-left-5"
          onClick={this._quickReturn}
        >
          <span>
            <i className="la la-space-shuttle" />
            <span>Quick Return</span>
          </span>
        </button>
        <button
          className="btn btn-outline-accent m-btn btn-sm  m-btn--icon m--margin-left-5"
          onClick={this._showModal}
        >
          <span>
            <i className="la 	la-undo" />
            <span>Return</span>
          </span>
        </button>
      </span>,

      <ModalToBody key="modal" render={showModal}>
        <div
          className="modal fade show"
          id="m_modal_4"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1039"
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Return {rental.material.name} {rental.code}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this._hideModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <RentalReturnForm rental={rental} onSubmit={this._handleSubmit} />
            </div>
          </div>
        </div>

        <div
          className={"modal-backdrop fade " + (showModal ? " show" : "")}
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1038"
          }}
        />
      </ModalToBody>
    ];
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReturnBtn)
);
